<template>
  <div class="date-range">
    <el-radio-group v-model="checkDate" @change="changeCheckDate">
      <el-radio-button
        v-for="item in dateOptions"
        :key="item.label"
        :label="item.value"
        >{{ item.label }}</el-radio-button
      > </el-radio-group
    >&nbsp;
    <el-date-picker
      v-model="selectDate"
      :value-format="valueFormat[type]"
      :type="type"
      range-separator="-"
      :default-time="defaulTime[type]"
      start-placeholder="start date"
      end-placeholder="end date"
      @change="changeDate"
    ></el-date-picker>
  </div>
</template>
<script>
import { getAfterDate, getDataTimeAfterDate, getLocalTime } from '@/utils'
import { cloneDeep, isEqual } from 'lodash'
const now = getAfterDate()
const utc4Flag = now === getAfterDate(0, 1)
export default {
  model: {
    prop: 'dateRange',
    event: 'change'
  },
  props: {
    dateRange: {
      type: Array,
      default() {
        return [now, now]
      }
    },
    type: {
      type: String,
      default: 'daterange' // datetimerange
    },
    utc4: {
      default() {
        return false
      }
    },
    isOutright: {
      type: Boolean
    }
  },
  data() {
    return {
      checkDate: 0,
      selectDate: cloneDeep(this.dateRange),
      valueFormat: {
        daterange: 'yyyy-MM-dd',
        datetimerange: 'timestamp'
      },
      defaulTime: {
        daterange: null,
        datetimerange: ['00:00:00', '23:59:59']
      },

      dateOptions: [
        {
          label: 'Today',
          value: 0
        },
        {
          label: 'Next 7d',
          value: 6
        }
        // {
        //   label: 'All Day',
        //   value: -1
        // }
      ]
    }
  },
  created() {
    if(this.isOutright) {
      this.dateOptions = [{label: 'Not Ended', value: 7}]
      this.checkDate = 7
      this.changeCheckDate(7)
      this.$parent.$parent.$parent.hasInit = true
    } else if(this.utc4) {
      this.dateOptions = [{label: `${getAfterDate(0, 1, '{m}-{d}')} (Today)`, value: 0},{label: `${getAfterDate(1, 1, '{m}-{d}')}`, value: 1},{label: `${getAfterDate(2, 1, '{m}-{d}')}`, value: 2}]
      const pushTimeFlag = this.$route.query.formatPushTime
      if(pushTimeFlag) {
        this.checkDate = ''
      }
      this.selectDate = pushTimeFlag? [+new Date(+new Date() - 5 * 60 * 60 * 1000 ), +new Date(+new Date() + 7 * 24 * 60 * 60 * 1000 )] : this.utc4Format()
       this.$parent.$parent.$parent.hasInit = true
    }
  },
  watch: {
    dateRange(val) {
      if (!isEqual(val, this.selectDate)) {
        this.selectDate = cloneDeep(val)
        this.changeDate(cloneDeep(val))
      }
    },
    selectDate(val) {
      if (!isEqual(val, this.dateRange)) {
        this.$nextTick(e => {
          this.$emit('change', val, this.checkDate)
        })
      }
    }
  },
  methods: {
    utc4Format(num = 0) {
      const date = getAfterDate(num + (utc4Flag ? 1 : 0))
      console.log(utc4Flag, date)
      const [start, end] = this.defaulTime.datetimerange
      return [getLocalTime(-4, date + ' ' + start), getLocalTime(-4, date + ' ' + end)]
    },
    changeCheckDate(val) {
      if (val !== -1) {
        if (this.type === 'daterange') {
          this.selectDate = [now, getAfterDate(val)]
        } else {
          if(val === 7) {
            this.selectDate = []
          } else {
            this.selectDate = this.utc4 ? this.utc4Format(val) : getDataTimeAfterDate(val)
          }
        }
      } else {
        this.selectDate = null
      }
    },
    changeDate(e) {
      let todayStart =
        this.type === 'daterange' ? getAfterDate() : getDataTimeAfterDate()[0]
      let todayEnd =
        this.type === 'daterange' ? getAfterDate() : getDataTimeAfterDate()[1]
      let next7DayEnd =
        this.type === 'daterange' ? getAfterDate(6) : getDataTimeAfterDate(6)[1]
      if (e) {
        if (e[0] === todayStart) {
          if (e[1] === todayEnd && this.checkDate !== 0) {
            this.checkDate = 0
          } else if (e[1] === next7DayEnd && this.checkDate !== 6) {
            this.checkDate = 6
          } else {
            this.checkDate = ''
          }
        } else {
          this.checkDate = ''
        }
      } else {
        this.checkDate = -1
      }
    }
  }
}
</script>
